'use client';

import React, { useState, useEffect } from 'react';

const StickyBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const threshold = window.innerHeight * 2;
    const handleScroll = () => {
      if (!dismissed && window.scrollY > threshold) {
        setVisible(true);
      } else if (window.scrollY <= threshold) {
        setVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [dismissed]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    /* Backend integration point: POST { email } to newsletter API */
    setSubmitted(true);
    setTimeout(() => {
      setDismissed(true);
      setVisible(false);
    }, 2500);
  };

  if (dismissed) return null;

  return (
    <div className={`sticky-banner ${visible ? 'visible' : ''}`}>
      <div
        style={{
          background: 'var(--color-charcoal)',
          borderTop: '2px solid var(--color-brass)',
        }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Left text */}
          <div className="flex items-center gap-4 flex-shrink-0">
            <span style={{ fontSize: '1.2rem' }}>📻</span>
            <div>
              <p
                className="font-display font-semibold text-sm leading-tight"
                style={{ color: 'var(--color-parchment)' }}
              >
                Get the Rundown
              </p>
              <p
                className="font-body text-xs"
                style={{ color: 'rgba(245,240,232,0.55)' }}
              >
                Weekly timestamps, guest links & one production note.
              </p>
            </div>
          </div>

          {/* Form */}
          {!submitted ? (
            <form
              onSubmit={handleSubmit}
              className="flex gap-2 items-center flex-1 max-w-sm"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="email-input flex-1 px-3 py-2 rounded-sm text-xs"
              />
              <button
                type="submit"
                className="btn-brass text-xs px-4 py-2 rounded-sm flex-shrink-0"
              >
                Subscribe
              </button>
            </form>
          ) : (
            <p
              className="font-display italic text-sm"
              style={{ color: 'var(--color-brass-light)' }}
            >
              ✓ You're subscribed. See you Monday.
            </p>
          )}

          {/* Dismiss */}
          <button
            onClick={() => { setDismissed(true); setVisible(false); }}
            className="flex-shrink-0 transition-opacity hover:opacity-60"
            style={{ color: 'rgba(245,240,232,0.4)' }}
            aria-label="Dismiss banner"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyBanner;